import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import JingusPage from "./components/JingusPage";
import Help from "./components/help"; // Ensure the path matches your folder structure

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<JingusPage />} />
          <Route path="/help" element={<Help />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
